export default __webpack_public_path__ + "static/media/11-ART-(3-2).4c0138d2.jpg";